import React, { useEffect, useState } from 'react';
import { BsArrowRight } from "react-icons/bs";
import { Link } from 'react-router-dom';
import arfinThumbnail from '../assets/images/Arfin_thumbnail.png';
import nogodThumbnail from '../assets/images/Nogod_thumbnail.png';
import shareTripThumbnail from '../assets/images/ShareTrip_thumbnail.png';
import instantCashback from '../assets/images/instant_cashback.png';
import upayThumbnail from '../assets/images/promotional-thumbnail-for-deshi-and-upay.png';
import Footer from '../components/Footer';
import HeaderOthers from '../components/HeaderOthers';
import Tab from '../components/Tab';

import bdt100CashBack from './../assets/images/offer/thumbnail/bdt-100-cashback_2.jpeg';
import convFeeFree from './../assets/images/offer/thumbnail/conv-fee-0_2.jpeg';
import saving3 from './../assets/images/offer/thumbnail/saving-3-2.jpeg';

const Offers = () => {
    const [activeTab, setActiveTab] = useState("AllOffers");
    useEffect(() => {
        window.scrollTo(0, -1);
    }, []);
    return (
        <>
            <HeaderOthers title="Offers" />
            <div className="mt-16 mb-10">
                <h1 className="text-[32px] font-medium text-center mb-10">Promotions</h1>
                <Tab activeTab={activeTab} setActiveTab={setActiveTab} />
                {activeTab === "AllOffers" &&
                    <div className="grid grid-cols-1 gap-4 px-12 lg:grid-cols-2 lg:gap-x-[30px] lg:gap-y-10">
                        {/* Added on 04-12-2023 */}
                        <div className="flex justify-center lg:justify-end">
                            <Link to="/offers/cashback100" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                                <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={bdt100CashBack} alt="BDT 100 cashback" />
                                <div className="flex flex-col justify-between p-4 leading-normal">
                                    <h5 className="mb-2 text-2xl font-medium text-title text-width">BDT 100 cashback on all services on payment through ST Pay</h5>
                                    <div className="group flex items-center space-x-[5px]">
                                        <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                        <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="flex justify-center lg:justify-start">
                            <Link to="/offers/conveniencefee0" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                                <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={convFeeFree} alt="Convenience Fee 0" />
                                <div className="flex flex-col justify-between p-4 leading-normal">
                                    <h5 className="mb-2 text-2xl font-medium text-title ">Convenience Fee 0% at ShareTrip</h5>
                                    <div className="group flex items-center space-x-[5px]">
                                        <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                        <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="flex justify-center lg:justify-end">
                            <Link to="/offers/saving3" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                                <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={saving3} alt="Extra 3% Savings" />
                                <div className="flex flex-col justify-between p-4 leading-normal">
                                    <h5 className="mb-2 text-2xl font-medium text-title ">Extra 3% Savings on ShareTrip</h5>
                                    <div className="group flex items-center space-x-[5px]">
                                        <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                        <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                    </div>
                                </div>
                            </Link>
                        </div>
                        {/* Added on 04-12-2023 End */}

                        <div className="flex justify-center lg:justify-start">
                            <Link to="/offers/shareTrip" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                                <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={instantCashback} alt="" />
                                <div className="flex flex-col justify-between p-4 leading-normal">
                                    <h5 className="mb-2 text-2xl font-medium text-title text-width">10% Instant Cashback at ShareTrip</h5>
                                    <div className="group flex items-center space-x-[5px]">
                                        <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                        <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="flex justify-center lg:justify-end">
                            <Link to="/offers/arfin" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                                <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={arfinThumbnail} alt="" />
                                <div className="flex flex-col justify-between p-4 leading-normal">
                                    <h5 className="mb-2 text-2xl font-medium text-title ">10% Discount on Arfin Voucher</h5>
                                    <div className="group flex items-center space-x-[5px]">
                                        <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                        <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                    </div>
                                </div>
                            </Link>
                        </div>

                        <div className="flex justify-center lg:justify-start">
                            <Link to="/offers/nagad" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                                <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={nogodThumbnail} alt="" />
                                <div className="flex flex-col justify-between p-4 leading-normal">
                                    <h5 className="mb-2 text-2xl font-medium text-title ">ST Pay Add Money from Nagad</h5>
                                    <div className="group flex items-center space-x-[5px]">
                                        <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                        <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="flex justify-center lg:justify-end">
                            <Link to="/offers/ShareTrip-two" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                                <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={shareTripThumbnail} alt="" />
                                <div className="flex flex-col justify-between p-4 leading-normal">
                                    <h5 className="mb-2 text-2xl font-medium text-title text-width">ShareTrip Vouchers for ST Pay Users</h5>
                                    <div className="group flex items-center space-x-[5px]">
                                        <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                        <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="flex justify-center lg:justify-start">
                            <Link to="/offers/upay" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                                <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={upayThumbnail} alt="ST Pay add money from Upay" />
                                <div className="flex flex-col justify-between p-4 leading-normal">
                                    <h5 className="mb-2 text-2xl font-medium text-title text-width">ST Pay add money from Upay</h5>
                                    <div className="group flex items-center space-x-[5px]">
                                        <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                        <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                }
            </div>


            {activeTab === "Cashback" && <div>
                <div className="grid grid-cols-1 gap-4 px-12 lg:grid-cols-2 lg:gap-x-[30px] lg:gap-y-10">
                    <div className="flex justify-center lg:justify-end">
                        <Link to="/offers/cashback100" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                            <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={bdt100CashBack} alt="BDT 100 cashback" />
                            <div className="flex flex-col justify-between p-4 leading-normal">
                                <h5 className="mb-2 text-2xl font-medium text-title text-width text-left">BDT 100 cashback on all services on payment through ST Pay</h5>
                                <div className="group flex items-center space-x-[5px]">
                                    <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                    <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>}
            {activeTab === "Discounts" &&
                <div className="grid grid-cols-1 gap-4 px-12 lg:grid-cols-2 lg:gap-x-[30px] lg:gap-y-10">
                    
                    <div className="flex justify-center lg:justify-end">
                        <Link to="/offers/conveniencefee0" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                            <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={convFeeFree} alt="Convenience Fee 0" />
                            <div className="flex flex-col justify-between p-4 leading-normal">
                                <h5 className="mb-2 text-2xl font-medium text-title ">Convenience Fee 0% at ShareTrip</h5>
                                <div className="group flex items-center space-x-[5px]">
                                    <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                    <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className="flex justify-center lg:justify-start">
                        <Link to="/offers/saving3" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                            <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={saving3} alt="Extra 3% Savings" />
                            <div className="flex flex-col justify-between p-4 leading-normal">
                                <h5 className="mb-2 text-2xl font-medium text-title ">Extra 3% Savings on ShareTrip</h5>
                                <div className="group flex items-center space-x-[5px]">
                                    <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                    <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                </div>
                            </div>
                        </Link>
                    </div>
                    
                    
                    <div className="flex justify-center  lg:justify-end">
                        <Link to="/offers/arfin" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                            <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={arfinThumbnail} alt="" />
                            <div className="flex flex-col justify-between p-4 leading-normal">
                                <h5 className="mb-2 text-2xl font-medium text-title ">10% Discount on Arfin Voucher</h5>
                                <div className="group flex items-center space-x-[5px]">
                                    <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                    <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className="flex justify-center lg:justify-start">
                        <Link to="/offers/nagad" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                            <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={nogodThumbnail} alt="" />
                            <div className="flex flex-col justify-between p-4 leading-normal">
                                <h5 className="mb-2 text-2xl font-medium text-title ">ST Pay Add Money from Nagad</h5>
                                <div className="group flex items-center space-x-[5px]">
                                    <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                    <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className="flex justify-center  lg:justify-end">
                        <Link to="/offers/ShareTrip-two" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                            <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={shareTripThumbnail} alt="" />
                            <div className="flex flex-col justify-between p-4 leading-normal">
                                <h5 className="mb-2 text-2xl font-medium text-title text-width">ShareTrip Vouchers for ST Pay Users</h5>
                                <div className="group flex items-center space-x-[5px]">
                                    <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                    <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className="flex justify-center lg:justify-start">
                        <Link to="/offers/upay" className="flex flex-col p-5 items-center bg-white rounded-lg box-shadow md:flex-row md:max-w-xl hover:bg-gray-100">
                            <img className="object-cover w-full h-auto rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" src={upayThumbnail} alt="ST Pay add money from Upay" />
                            <div className="flex flex-col justify-between p-4 leading-normal">
                                <h5 className="mb-2 text-2xl font-medium text-title text-width">ST Pay add money from Upay</h5>
                                <div className="group flex items-center space-x-[5px]">
                                    <p className="font-medium text-base text-[#999999] group-hover:text-[#158560]">Explore</p>
                                    <BsArrowRight fill="#999999" className="group-hover:fill-[#158560] mt-0.5" />
                                </div>
                            </div>
                        </Link>
                    </div>

                </div>
            }
            {activeTab === "ReferBonus" && <div className='text-center'><h3>Refer Bonus coming soon...</h3></div>}
            {activeTab === "GetPoints" && <div className='text-center'><h3>Get Points coming soon...</h3></div>}


            <div>
                <Footer />
            </div>
            <style>
                {`
                    @media screen and (min-width: 542px) and (max-width: 768px) {
                        .text-width{
                        width: 373.25px;
                        }
                    `}
            </style>
        </>
    );
};

export default Offers;